import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const DEFAULT_SECTOR = {
  restaurant_type: "Hospitality", label: "Hospitality", guest: "guest", team: "team",
  kpis: { labour: "Labour cost", service: "Service quality", training: "Training progress" },
  roles: [], compliance: [], checklists: [], announcements: [], metrics: [], is_demo: false,
  focus: "great guest experience and smooth daily operations",
};

const SectorContext = createContext({ sector: DEFAULT_SECTOR, loading: true, refresh: () => {} });

const MEMBER_ROLES = ["owner", "manager", "staff"];

export function SectorProvider({ children }) {
  const { user } = useAuth();
  const [sector, setSector] = useState(DEFAULT_SECTOR);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    if (!user || !MEMBER_ROLES.includes(user.role)) {
      setSector(DEFAULT_SECTOR);
      setLoading(false);
      return;
    }
    setLoading(true);
    api.get("/sector-profile")
      .then((r) => setSector({ ...DEFAULT_SECTOR, ...r.data }))
      .catch(() => setSector(DEFAULT_SECTOR))
      .finally(() => setLoading(false));
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SectorContext.Provider value={{ sector, loading, refresh }}>
      {children}
    </SectorContext.Provider>
  );
}

export function useSector() {
  return useContext(SectorContext);
}
